import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import {
  getCurrentFYByDate,
  minutesToHHMM,
  secondsToHHMM,
  timeToSeconds,
} from "../../../Utilitie";
import axios from "axios";

const StaffStrengthIns = ({ Id }) => {
  const [entries, setEntries] = useState([
    {
      designation: "",
      grade_pay: "",
      sanctioned_strength: "",
      on_roll: "",
      vacancy: "",
    },
  ]);

  const keys = [
    "designation",
    "grade_pay",
    "sanctioned_strength",
    "on_roll",
    "vacancy",
  ];
  const handleChange = (rowIndex, key, value) => {
    setEntries((prev) =>
      prev.map((row, i) => {
        if (i !== rowIndex) return row;

        const updated = { ...row };

        updated[key] = value;

        return updated;
      })
    );
  };

  const addRow = () => {
    setEntries((prev) => [
      ...prev,
      {
        designation: "",
        grade_pay: "",
        sanctioned_strength: "",
        on_roll: "",
        vacancy: "",
      },
    ]);
  };

  const removeRow = (index) =>
    setEntries((prev) => prev.filter((_, i) => i !== index));
  const handleClear = () => setEntries([]);

  const handleSubmit = async () => {
    const dataToSend = entries.map((entry) => ({
      ...entry,
      station_id: Id || "",
    }));

    try {
      const response = await fetch(
        `https://railsetu.in:5020/insert-station-staff-strength
`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(dataToSend),
        }
      );

      const result = await response.json();
      if (!response.ok) throw new Error(result?.message || "HTTP error");

      toast.success("✅ Data uploaded successfully!");
      setEntries([
        {
          designation: "",
          grade_pay: "",
          sanctioned_strength: "",
          on_roll: "",
          vacancy: "",
        },
      ]);
    } catch (error) {
      toast.error("❌ Failed to upload data");
      console.error("Upload error:", error);
    }
  };

  return (
    <div className="papaDiv">
      <h5 className="p-2 bg-dark text-white text-center">
        Insert Data in Staff Strength
      </h5>

      <div className="table-responsive">
        <table className="table table-bordered table-striped mb-4 text-center align-middle">
          <thead className="table-dark">
            <tr>
              {keys.map((key, i) => (
                <th key={i}>{key.replace(/_/g, " ").toUpperCase()}</th>
              ))}
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {entries.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {keys.map((key, index) => (
                  <td key={index}>
                    {key === "designation" ? (
                      <input
                        type="text"
                        className="form-control"
                        value={row[key] || ""}
                        onChange={(e) =>
                          handleChange(rowIndex, key, e.target.value)
                        }
                      />
                    ) : (
                      <input
                        type="number"
                        className="form-control"
                        style={{ fontSize: "0.8rem" }}
                        value={row[key]}
                        onChange={(e) =>
                          handleChange(rowIndex, key, e.target.value)
                        }
                      />
                    )}
                  </td>
                ))}

                <td>
                  <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => removeRow(rowIndex)}
                  >
                    🗑
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="text-center mt-3">
        <button className="btn btn-outline-primary m-2" onClick={addRow}>
          Add Row
        </button>
        <button className="btn btn-outline-danger m-2" onClick={handleClear}>
          Clear
        </button>
        <button className="btn btn-outline-success m-2" onClick={handleSubmit}>
          Upload
        </button>
      </div>
    </div>
  );
};

export default StaffStrengthIns;
